import { apiClient } from '../client/apiClient';
import type { ICategory } from '../types/category';
import type {
	IBaseResponse,
	IPaginatedResponse,
	IPagination,
} from '../types/common';
import type { IConversation } from '../types/conversation';
import type { IUser } from '../types/user';

export const categoryService = {
	/**
	 * Get list of all categories
	 */
	getCategories: () =>
		apiClient.get<IBaseResponse<ICategory[]>>('/categories/list'),

	/**
	 * Get popular categories with pagination
	 */
	getPopularCategories: (params: IPagination) =>
		apiClient.get<IPaginatedResponse<ICategory>>('/categories/popular', {
			params,
		}),

	/**
	 * Get detailed information about a specific category
	 */
	getCategoryInfo: (category: string) =>
		apiClient.get<IBaseResponse<ICategory>>(`/categories/${category}/info`),

	/**
	 * Get related categories for a specific category
	 */
	getRelatedCategories: (category: string) =>
		apiClient.get<IBaseResponse<ICategory[]>>(
			`/categories/${category}/related`,
		),

	/**
	 * Get followers of a specific category
	 */
	getCategoryFollowers: (category: string, params: IPagination) =>
		apiClient.get<IPaginatedResponse<IUser>>(
			`/categories/${category}/followers`,
			{ params },
		),

	/**
	 * Get conversations in a specific category
	 */
	getCategoryConversations: (category: string, params: IPagination) =>
		apiClient.get<IPaginatedResponse<IConversation>>(
			`/categories/${category}/conversations`,
			{ params },
		),

	/**
	 * Follow a category
	 */
	followCategory: (category: string) =>
		apiClient.post<IBaseResponse<{ count: number }>>(
			`/categories/${category}/follow`,
		),

	/**
	 * Unfollow a category
	 */
	unfollowCategory: (category: string) =>
		apiClient.post<IBaseResponse<{ count: number }>>(
			`/categories/${category}/unfollow`,
		),

	/**
	 * Report a category
	 */
	reportCategory: (category: string) =>
		apiClient.post<IBaseResponse<void>>(`/categories/${category}/report`),
};
